var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Input } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
var MiscellaneousComponentForm = /** @class */ (function (_super) {
    __extends(MiscellaneousComponentForm, _super);
    function MiscellaneousComponentForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onDescriptionChange = function (_, data) {
            _this.props.onMiscComponentChange({
                description: data.value
            }, _this.props.onUserSelection);
        };
        _this.onReagentScaleMlChange = function (_, data) {
            var scale = data.value;
            if (!scale || scale.match(/^\d{1,}(\.\d{0,4})?$/)) {
                _this.props.onMiscComponentChange({
                    scaleInMl: Number(scale),
                    scaleInMlText: scale
                }, _this.props.onUserSelection);
            }
        };
        _this.onReagentScaleSlideChange = function (_, data) {
            var scale = data.value;
            var num = parseInt(scale, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.props.onMiscComponentChange({
                scaleInSlides: num
            }, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onMiscComponentChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    MiscellaneousComponentForm.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 3, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/miscComponent/description', labelContent: React.createElement(React.Fragment, null, "Reagent Description") },
                            React.createElement(Input, { onChange: this.onDescriptionChange, value: this.props.miscComponentState.description }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/miscComponent/scaleInMl', labelContent: React.createElement(React.Fragment, null, "Reagent Scale (ml)") },
                            React.createElement(Input, { onChange: this.onReagentScaleMlChange, value: this.props.miscComponentState.scaleInMlText, type: 'string' }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/miscComponent/scaleInSlides', labelContent: React.createElement(React.Fragment, null, "Reagent Scale (slides)") },
                            React.createElement(Input, { onChange: this.onReagentScaleSlideChange, value: this.props.miscComponentState.scaleInSlides, type: 'number' })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    priceColumn(React.createElement(PriceDisplay, { loading: this.props.priceLoading, priceCents: this.props.priceCents }))),
                this.props.enableCustomPrice && React.createElement(CustomPriceRow, { customPrice: this.props.miscComponentState.customPrice, defaultEffectivePriceCents: this.props.priceCents, disabled: this.props.customPriceLocked, errors: this.props.errors, errorPathPrefix: '/miscComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })));
    };
    return MiscellaneousComponentForm;
}(React.PureComponent));
export default MiscellaneousComponentForm;
//# sourceMappingURL=MiscellaneousComponentForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/MiscellaneousComponentForm.js
// module id = 1146
// module chunks = 0